export default __webpack_public_path__ + "static/segalconcerto-4763bc4b7fe2d400a715480d6de078ec.jpg";